module.exports = __webpack_public_path__ + "img/non_active.b7979056.svg";